import React from 'react'

import { useGlobalSearch } from '@/components/misc/GlobalSearch/hooks/useGlobalSearch'
import { Button } from '@/components/ui/button'
import { useInviteToRqModal } from '@/hooks/useInviteToRqModal'
import { usePrefetchReferralSetupQuery } from '@/hooks/usePrefetchReferralSetupQuery'
import { useReferToAdviserEmail } from '@/pages/referClient/hooks/useReferToAdviserEmail'

const NoResultsMessage: React.FC = () => {
  const globalSearch = useGlobalSearch()
  const inviteToRqModal = useInviteToRqModal()
  const prefetchReferralSetupQuery = usePrefetchReferralSetupQuery()
  const referToAdviserEmail = useReferToAdviserEmail()

  return (
    <div className="flex flex-col items-center gap-4 px-4 py-6">
      <p className="mb-0 text-center text-sm">
        <span className="text-muted-foreground">No results for </span>
        <span className="font-medium break-words text-black">
          "{globalSearch.searchTerm}"
        </span>
      </p>

      <div
        className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2"
      >
        <Button
          variant="success"
          className="w-full sm:w-auto"
          size="sm"
          onClick={() => {
            globalSearch.hide()
            inviteToRqModal.show()
          }}
        >
          Invite a partner to RQ
        </Button>

        <Button
          variant="primary"
          className="w-full sm:w-auto"
          size="sm"
          onMouseOver={prefetchReferralSetupQuery}
          onClick={() => {
            globalSearch.hide()
            referToAdviserEmail()
          }}
        >
          Refer to someone not on RQ
        </Button>
      </div>
    </div>
  )
}

export default NoResultsMessage
